import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SeTakebackTransport } from '../../model/supplementary-equipment-take-back.model';
import { SupplementaryEquipmentTakeBackService } from '../../service/supplementary-equipment-take-back.service';
import { Identity, TranslationService } from '@sdbn/common';

@Component({
    selector: 'app-supplementary-equipment-take-back',
    templateUrl: './supplementary-equipment-take-back.component.html',
    styleUrls: ['./supplementary-equipment-take-back.component.scss'],
    standalone: false
})
export class SupplementaryEquipmentTakeBackComponent implements OnInit {

  transport = new SeTakebackTransport();
  isLoading = false;

  identity;

  formGroup = new UntypedFormGroup({});

  constructor(
    public dialogRef: MatDialogRef<SupplementaryEquipmentTakeBackComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private seService: SupplementaryEquipmentTakeBackService,
    public translationService: TranslationService) {

    this.isLoading = true;
    this.identity = new Identity();
    this.identity.id = data.transportId;

  }

  ngOnInit() {
    this.seService.getTransport(this.identity).subscribe(response => {
      this.isLoading = false;
      this.transport = response;
      this.setupForm();
    }, error => {
      this.isLoading = true;
      console.error(error);
    });
  }

  private setupForm() {
    console.log('setupForm', this.transport?.supplementaryEquipments);
    this.transport.supplementaryEquipments.forEach( (se, index) => {
      const equipmentFormGroup = new UntypedFormGroup({
        index: new UntypedFormControl(index),
        equipmentTypeId: new UntypedFormControl(se.equipmentTypeId),
        selected: new UntypedFormControl(false),
        identifier: new UntypedFormControl(se.identifier)
      });
      this.formGroup.addControl('' + index, equipmentFormGroup);
      equipmentFormGroup.controls.identifier.disable();
      equipmentFormGroup.valueChanges.subscribe(values => {
        this.transport.supplementaryEquipments[values.index].selected = values.selected;
      });
    });

  }

  supplementaryEquipmendHandouted(transport: SeTakebackTransport): boolean {
    return transport.supplementaryEquipments != null && transport.supplementaryEquipments.length > 0;
  }

  isSaveDisabled(): boolean {

    if (this.isLoading) {
      return true;
    }
    if (this.transport.supplementaryEquipments.findIndex((se) => se.selected === true) === -1) {
      return true;
    }
    return false;
  }

  cancel() {
    this.dialogRef.close();
  }

  save() {
    this.isLoading = true;
    this.seService.saveTransport(this.transport).subscribe(response => {
      this.isLoading = false;
      this.dialogRef.close();
    }, error => {
      this.isLoading = false;
      console.log(error);
    });
  }

  isFormReadonly() {
    return this.isLoading;
  }
}
